import React from 'react';
import { useI18n } from '../i18n';
import './LegalDocs.css';

const termsCopy = {
  es: {
    title: 'T\u00c9RMINOS Y CONDICIONES DE USO',
    updated: '\u00daltima actualizaci\u00f3n: 22 de Febrero de 2026',
    sections: [
      {
        title: '1. ACEPTACI\u00d3N DE LOS T\u00c9RMINOS',
        body: ['Al registrarte, acceder o utilizar Qproject, confirmas que eres mayor de edad (18 a\u00f1os o la mayor\u00eda de edad en tu jurisdicci\u00f3n) y aceptas estos T\u00e9rminos y Condiciones en su totalidad.']
      },
      {
        title: '2. NATURALEZA EXPERIMENTAL DEL SISTEMA DE IA',
        body: ['Qproject utiliza Modelos de Lenguaje Grande (LLMs). Usted comprende y acepta que:'],
        bullets: [
          'Las respuestas generadas por m\u00f3dulos como "Conciencia" est\u00e1n dise\u00f1adas para ser introspectivas, incisivas o provocadoras por dise\u00f1o.',
          'La IA puede generar contenido surrealista, inexacto o que no represente un consejo psicol\u00f3gico, m\u00e9dico o profesional real.',
          'Qproject no es una herramienta de salud mental, terapia ni diagn\u00f3stico.'
        ]
      },
      {
        title: '3. PROPIEDAD INTELECTUAL Y LICENCIAMIENTO',
        bullets: [
          'Sus Datos (Input): Usted conserva la plena propiedad intelectual y los derechos morales sobre sus datos de entrada.',
          'El Software (Plataforma): El c\u00f3digo fuente, la arquitectura del sistema, los algoritmos de orquestaci\u00f3n y la interfaz gr\u00e1fica son propiedad exclusiva de Qproject.',
          'El Modelo Resultante: Se le otorga una licencia de uso perpetua, no exclusiva y revocable sobre su extensi\u00f3n digital mientras mantenga una cuenta activa y cumpla estos t\u00e9rminos.'
        ]
      },
      {
        title: '4. RESTRICCIONES Y USO PROHIBIDO',
        body: ['El usuario se compromete a no realizar las siguientes acciones. Su incumplimiento derivar\u00e1 en el baneo permanente:'],
        bullets: [
          'Intentar clonar la voz, identidad o patrones de comportamiento de terceros sin consentimiento escrito y expl\u00edcito.',
          'Utilizar la plataforma para generar deepfakes maliciosos, estafas o contenido ilegal.',
          'Sobrecargar servidores intencionalmente o abusar de endpoints de procesamiento LLM.',
          'Realizar ingenier\u00eda inversa sobre APIs, autenticaci\u00f3n o c\u00f3digo fuente de Qproject.'
        ]
      },
      {
        title: '5. LIMITACI\u00d3N DE RESPONSABILIDAD',
        body: ['Qproject se proporciona "tal cual" y "seg\u00fan disponibilidad". No nos hacemos responsables por da\u00f1os directos o indirectos, estr\u00e9s emocional derivado de la interacci\u00f3n con perfiles psicol\u00f3gicos de IA, p\u00e9rdida de datos o fallos de seguridad imprevistos, en la m\u00e1xima medida permitida por la ley aplicable.']
      },
      {
        title: '6. MODIFICACIONES Y JURISDICCI\u00d3N',
        body: [
          'Qproject se reserva el derecho de modificar estos t\u00e9rminos. Los cambios sustanciales requerir\u00e1n un nuevo consentimiento expl\u00edcito de su parte.',
          'Estos t\u00e9rminos se rigen por las leyes de la Rep\u00fablica Argentina. Cualquier disputa ser\u00e1 resuelta en los tribunales ordinarios correspondientes, sin perjuicio de derechos de consumidores bajo legislaciones internacionales si acceden desde dichas regiones.'
        ]
      },
      {
        title: 'GENERACI\u00d3N POR INTELIGENCIA ARTIFICIAL',
        body: ['De conformidad con las normativas europeas vigentes, se advierte expresamente que todo el texto generado, los contenidos, las narrativas on\u00edricas y las im\u00e1genes mostradas en la plataforma son creados de forma sint\u00e9tica mediante modelos avanzados de Inteligencia Artificial.']
      }
    ],
    contact: 'Contacto Legal y Ejercicio de Derechos:',
    contactText: 'Para consultas sobre estos t\u00e9rminos o para ejercer sus derechos de datos, escriba a:'
  },
  en: {
    title: 'TERMS AND CONDITIONS OF USE',
    updated: 'Last updated: February 22, 2026',
    sections: [
      {
        title: '1. ACCEPTANCE OF TERMS',
        body: ['By registering, accessing or using Qproject, you confirm that you are of legal age (18 years old or the age of majority in your jurisdiction) and accept these Terms and Conditions in full.']
      },
      {
        title: '2. EXPERIMENTAL NATURE OF THE AI SYSTEM',
        body: ['Qproject uses Large Language Models (LLMs). You understand and accept that:'],
        bullets: [
          'Responses generated by modules such as "Consciousness" are intentionally introspective, incisive or provocative by design.',
          'AI may generate surreal, inaccurate content that does not constitute psychological, medical or professional advice.',
          'Qproject is not a mental health tool, therapy service or diagnostic system.'
        ]
      },
      {
        title: '3. INTELLECTUAL PROPERTY AND LICENSING',
        bullets: [
          'Your Data (Input): You retain full intellectual property and moral rights over your input data.',
          'The Software (Platform): Source code, system architecture, orchestration algorithms and graphical interface are the exclusive property of Qproject.',
          'The Resulting Model: You receive a perpetual, non-exclusive and revocable license to use your digital extension while your account remains active and you comply with these terms.'
        ]
      },
      {
        title: '4. RESTRICTIONS AND PROHIBITED USE',
        body: ['You agree not to perform the following actions. Breach may result in permanent banning:'],
        bullets: [
          'Clone the voice, identity or behavior patterns of third parties without explicit written consent.',
          'Use the platform to generate malicious deepfakes, scams or illegal content.',
          'Intentionally overload servers or abuse LLM processing endpoints.',
          'Reverse engineer Qproject APIs, authentication flows or source code.'
        ]
      },
      {
        title: '5. LIMITATION OF LIABILITY',
        body: ['Qproject is provided "as is" and "as available". To the maximum extent permitted by applicable law, we are not liable for direct or indirect damages, emotional stress derived from interaction with AI psychological profiles, data loss or unforeseen security failures.']
      },
      {
        title: '6. MODIFICATIONS AND JURISDICTION',
        body: [
          'Qproject reserves the right to modify these terms. Material changes will require your explicit consent again.',
          'These terms are governed by the laws of the Argentine Republic. Disputes will be resolved by the corresponding ordinary courts, without prejudice to consumer rights under international regulations where applicable.'
        ]
      },
      {
        title: 'ARTIFICIAL INTELLIGENCE GENERATION',
        body: ['In compliance with applicable European regulations, you acknowledge and agree that all generated text, content, dream narratives, and images displayed within the platform are synthetically created using advanced Artificial Intelligence models.']
      }
    ],
    contact: 'Legal Contact and Rights Requests:',
    contactText: 'For questions about these terms or to exercise your data rights, write to:'
  }
};

const Terms = () => {
  const { language } = useI18n();
  const copy = termsCopy[language] || termsCopy.es;

  return (
    <div className="legal-docs-container">
      <div className="legal-docs-content">
        <h1>{copy.title}</h1>
        <span className="legal-update-date">{copy.updated}</span>

        {copy.sections.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            {section.body?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            {section.bullets && (
              <ul>
                {section.bullets.map((item) => <li key={item}>{item}</li>)}
              </ul>
            )}
          </section>
        ))}

        <hr />
        <p style={{ textAlign: 'center', fontSize: '0.9rem' }}>
          <strong>{copy.contact}</strong><br />
          {copy.contactText} <a href="mailto:quiddit.contact@gmail.com" style={{ color: 'var(--accent-color)' }}>quiddit.contact@gmail.com</a>
        </p>
      </div>
    </div>
  );
};

export default Terms;
